import React, { useCallback, useEffect, useMemo, useState } from "react";
import Dropdown from "../../components/inputs/Dropdown";
import PageHeading from "../../components/PageHeading";
import { Input } from "../../components/inputs/Inputs";
import {
  BankCodeFinder,
  base_url,
  downloadExcel,
  exportPDF,
} from "../../utils/utils";
import { useSelector } from "react-redux";
import store from "../../redux/store";
import {
  get_bank_master_list,
  get_staff_list,
} from "../MasterData/masterdataSlice";
import moment from "moment";
import TableNew from "../../components/table/TableWithPagination";
import PageLoading from "../../components/PageLoading";

import { Button } from "../../components/btn/Buttons";
import { get_payroll_report } from "./payrollSlice";
import { monthData, payrollReportHeader } from "../../utils/data";
import useLastFourFinancialYears from "../../utils/Hook/financialYearHook";
import { Pagination3 } from "../../components/pagination/pagination";
import {
  getOptionLabel,
  getPaidMonthLabel,
  getPaymentMode,
} from "../../utils/OtherFuncs";
import { EmptyDataHook } from "../../utils/Hook/EmptyDataHook";
import SearchApiHook from "../../CustomHooks/SearchApiHook";
import { toast } from "react-toastify";
import usePaginationState from "../../CustomHooks/usePaginationState";
import {
  setMessAlert,
  setOpenAlert,
  setLoadingMain,
} from "../../redux/slice/actionSlice";
import { downloadFile, downloadFile2 } from "../../utils/Hook/DownloadFile";

const Reports = () => {
  const [showData, setShowData] = useState(false);
  const {
    entries,
    setEntries,
    pageNo,
    setPageNo,
    searchInput,
    setSearchInput,
    totalCount,
    setTotalCount,
    searchCount,
    setSearchCount,
    prevSearch,
    setPrevSearch,
  } = usePaginationState();
  const [addData, setAddData] = useState({
    action: "staffSalaryLedger",
    title: "Staff-Salary-Ledger",
  });
  const [addDataPre, setAddDataPre] = useState({});
  const { user_id } = useSelector((state) => state.other);

  const { bank_master_list, staff_list } = useSelector(
    (state) => state.masterdata
  );
  const { payroll_report_list, payroll_report_loading } = useSelector(
    (state) => state.payroll
  );
  const { firm_name } = useSelector((state) => state.profile);
  const ChangeAction = (data) => {
    if (data) {
      setAddData({ ...EmptyDataHook(addData), ...data });
      setShowData(false);
      setPageNo(1);
      setEntries(5);
      setSearchInput("");
    }
  };

  const apiData = {
    body: {
      action: addData.action,
      agencyid: user_id,
      month: Number(addData?.month),
      year: parseInt(addData?.year),
      page: pageNo,
      limit: entries,
      search: searchInput,
      fromDate: addData?.fromDate,
      toDate: addData?.toDate,
      staffId: addData?.staffId || "",
      mop: addData.mop || "",
      bankId: addData?.mop == 1 ? 0 : addData?.bankId || "",
    },
    data: {
      setTotalCount,
      setSearchCount,
    },
  };

  const fetchData = () => {
    store.dispatch(get_payroll_report(apiData));
  };

  SearchApiHook(fetchData, searchInput?.trim(), prevSearch, [entries, pageNo]);

  const handleFetchData = async () => {
    const data1 = currentConfig.validate().filter(Boolean);
    if (data1.length === 0) {
      fetchData();
      setShowData(true);
      setAddDataPre(addData);
    } else {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(data1));
    }
  };

  const handleInputChange = (key) => (event) => {
    setAddData({
      ...addData,
      [key]: event.target.value,
    });
  };

  useEffect(() => {
    store.dispatch(get_bank_master_list());
    store.dispatch(get_staff_list());
  }, []);

  const getBankCode = useMemo(() => {
    return (id) => BankCodeFinder(bank_master_list, id);
  }, [bank_master_list]);

  const options = useLastFourFinancialYears(8);

  const validateField = (condition, message) => (condition ? null : message);

  const reportTypes = {
    "Staff-Salary-Ledger": {
      fields: [
        {
          label: "MONTH:",
          key: "month",
          type: "dropdown",
          data: monthData.map((v) => ({ value: v?.id, label: v?.label })),
        },
        {
          label: "YEAR:",
          key: "year",
          type: "dropdown",
          options: options,
        },
        {
          label: "PAYMENT MODE:",
          key: "mop",
          type: "dropdown",

          data: [
            { value: "1", label: "CASH" },
            { value: "2", label: "CHEQUE" },
            { value: "3", label: "ONLINE" },
          ],
        },
        {
          label: "BANK :",
          key: "bankId",
          type: "dropdown",
          disable: addData?.mop == 1,
          data: bank_master_list
            ?.filter(
              (v) =>
                v?.BANK_CODE == "OVER DRAFT" ||
                v?.BANK_CODE == "LOAN" ||
                v?.BANK_CODE == "SAVINGS" ||
                v?.BANK_CODE == "CURRENT"
            )
            ?.map((v) => ({
              value: v?.ID,
              label: getBankCode(v?.ID),
              // label: `${v?.BANK_CODE} - ${v?.BANK_ACC_NO}`,
            })),
          valueKey: "bankId",
        },
      ],
      buttonLabel: "SEARCH",
      validate: () => [
        // validateField(user_id, "User ID is required."),
        // validateField(addData.bankId, "Selected bank is required."),
        validateField(addData.month, "Selected month is required."),
        validateField(addData.year, "Selected year is required."),
        validateField(addData.mop, "Selected payment mode is required."),
      ],
    },

    "Staff-Loan-Ledger": {
      fields: [
        {
          label: "FROM DATE:",
          key: "fromDate",
          type: "date",
        },
        {
          label: "TO DATE:",
          key: "toDate",
          type: "date",
        },
        {
          label: "STAFF NAME :",
          key: "staffId",
          type: "dropdown",
          data: staff_list?.map((v) => ({
            value: v?.ID,
            label: v?.EMP_NAME,
          })),
        },
      ],
      buttonLabel: "SEARCH",
      validate: () => [
        validateField(user_id, "User ID is required."),
        validateField(addData.fromDate, "From date is required."),
        validateField(addData.toDate, "To date is required."),
      ],
    },
    "Staff-Advance-Ledger": {
      fields: [
        {
          label: "FROM DATE:",
          key: "fromDate",
          type: "date",
        },
        {
          label: "TO DATE:",
          key: "toDate",
          type: "date",
        },
        {
          label: "STAFF NAME :",
          key: "staffId",
          type: "dropdown",
          data: staff_list?.map((v) => ({
            value: v?.ID,
            label: v?.EMP_NAME,
          })),
        },
      ],
      buttonLabel: "SEARCH",
      validate: () => [
        validateField(user_id, "User ID is required."),
        validateField(addData.fromDate, "From date is required."),
        validateField(addData.toDate, "To date is required."),
      ],
    },

    "ESI-REPORT": {
      fields: [
        {
          label: "MONTH:",
          key: "month",
          type: "dropdown",
          data: monthData.map((v) => ({ value: v?.id, label: v?.label })),
        },
        {
          label: "YEAR:",
          key: "year",
          type: "dropdown",
          options: options,
        },
      ],
      buttonLabel: "EXECUTE",
      validate: () => [
        validateField(user_id, "User ID is required."),
        validateField(addData.month, "Selected month is required."),
        validateField(addData.year, "Selected year is required."),
      ],
    },

    "PF-REPORT": {
      fields: [
        {
          label: "MONTH:",
          key: "month",
          type: "dropdown",
          data: monthData.map((v) => ({ value: v?.id, label: v?.label })),
        },
        {
          label: "YEAR:",
          key: "year",
          type: "dropdown",
          options: options,
        },
      ],
      buttonLabel: "EXECUTE",
      validate: () => [
        validateField(addData.month, "Selected month is required."),
        validateField(addData.year, "Selected year is required."),
      ],
    },

    default: {
      fields: [],
      buttonLabel: "EXECUTE",
      validate: () => [
        validateField(addData.month, "Selected month is required."),
        validateField(addData.year, "Selected year is required."),
      ],
    },
  };

  const currentConfig = reportTypes[addData?.title] || reportTypes.default;

  const HeaderData = payrollReportHeader[addData?.title];

  const getRoleOption = useCallback(
    (role) => getOptionLabel(role),
    [payroll_report_list]
  );
  const getPaidMonthOption = useCallback(
    (month, year) => getPaidMonthLabel(month, year),
    [payroll_report_list]
  );
  const getModeOfPayment = useCallback(
    (payment_mode) => getPaymentMode(payment_mode),
    [payroll_report_list]
  );

  const tableData = (data) => {
    const updateddata = [
      ...data?.map((item, i) => [
        i + 1,
        ...Object.keys(HeaderData).map((val, ind) =>
          val == "role"
            ? getRoleOption(item?.[val])
            : val == "MONTH"
            ? getPaidMonthOption(item?.[val], item?.YEAR)
            : val == "PAYMENT_MODE"
            ? getModeOfPayment(item?.[val])
            : val == "BANK_ID"
            ? getBankCode(item?.[val])
            : val == "SALARY_PAID_DATE" || val == "DATE"
            ? moment(item[val]).format("DD-MMM-YYYY")
            : item[val]
        ),
      ]),
    ];
    return updateddata;
  };

  const downloadReport = async (data, type) => {
    try {
      const body = {
        action: data.action,
        agencyid: user_id,
        month: Number(data?.month),
        year: parseInt(data?.year),
        page: 1,
        limit: totalCount,
        search: prevSearch,
        fromDate: data?.fromDate,
        toDate: data?.toDate,
        staffId: data?.staffId || "",
        mop: data.mop || "",
        bankId: data?.bankId || "",
      };
      const response = await fetch(`${base_url}payroll/payrollReports.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        const table_header = [
          "S.No.",
          ...Object.values(HeaderData).map((v, i) => v),
        ];
        const file_name = `MyLPGBooks DEALER APPLICATION - ${data?.title.toUpperCase()}  - ${
          data?.title == "Staff-Loan-Ledger" ||
          data?.title == "Staff-Advance-Ledger"
            ? `FROM DATE : ${moment(data?.fromDate).format(
                "DD-MMM-YYYY"
              )} TO DATE : ${moment(data?.toDate).format(
                "DD-MMM-YYYY"
              )} STAFF ID : ${data?.staffId}`
            : `MONTH : ${
                monthData.find((v) => v?.id == data?.month).label
              } YEAR : ${data?.year} ${
                data?.title == "Staff-Salary-Ledger"
                  ? `PAYEMENT MODE : ${
                      data?.mop == 1
                        ? "CASH"
                        : data?.mop == 2
                        ? "CHEQUE"
                        : data?.mop == 3
                        ? "ONLINE"
                        : ""
                    }`
                  : ""
              }`
        }`;
        const table_data = tableData(res.data);
        if (type == "pdf") {
          exportPDF({
            table_data: table_data,
            table_headers: table_header,
            fileName: file_name,
            tableName: file_name,
          });
        } else if (type == "excel") {
          downloadExcel(table_data, table_header, file_name);
        }
        toast.success(`${type.toUpperCase()} File download successfully`);
      }
    } catch (error) {
      console.error("Error fetching data:", error?.message);
    }
  };

  const handlePrintSalarySlip = async (item) => {
    console.log("item ===>", item);
    
    try {
      store.dispatch(setLoadingMain(true));
      const body = {
        action: "salarySlipDownload",
        agencyid: user_id,
        salaryID: item?.ID,
      };
      const response = await fetch(`${base_url}payroll/payrollReports.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }

      const blob = await response.blob();

      // Create a blob URL and open in a new tab
      const url = window.URL.createObjectURL(blob);
      downloadFile2(url,`${item.STAFF_TYPE == 1 && item.role == 0 ? "Commission" : "Payslip"}_${getPaidMonthOption(
        item?.MONTH,
        item?.YEAR
      )}_${item?.emp_name}.pdf`);

      // Optional: Revoke the URL after a while (to free up memory)
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } catch (error) {
      console.log("error ===>", error);
    } finally {
      store.dispatch(setLoadingMain(false));
    }
  };

  return (
    <div className="container">
      <div className="ReportsMain">
        <PageHeading
          title={addData?.title.toUpperCase()}
          right={
            <RightButtonComponent
              addData={addData}
              ClickEvent={(data) => ChangeAction(data)}
            />
          }
        />
      </div>
      {currentConfig && (
        <div className="tb1 mt20">
          <div
            className="MonYear"
            style={{ display: "flex", alignItems: "center" }}
          >
            {currentConfig.fields.map((field, index) => (
              <React.Fragment key={index}>
                <p style={{ fontSize: "14px" }}>{field.label}</p>
                <div className="DR">
                  {field.type === "dropdown" ? (
                    <Dropdown
                      value={addData[field.valueKey || field.key]}
                      onChange={handleInputChange(field.key)}
                      data={field.data}
                      disabled={field.disable}
                      options={
                        !field.data && (
                          <>
                            <option value="">SELECT</option>
                            {options}
                          </>
                        )
                      }
                    />
                  ) : (
                    <div style={{ width: "180px" }}>
                      <Input
                        type="date"
                        value={addData[field.key]}
                        onChange={handleInputChange(field.key)}
                      />
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}

            <Button
              title={currentConfig.buttonLabel}
              onClick={handleFetchData}
            />
          </div>
        </div>
      )}

      {showData && (
        <div className="mt20">
          <Pagination3
            count={0}
            download={true}
            showSearch={true}
            PDFDown={() => downloadReport(addDataPre, "pdf")}
            excelDown={() => downloadReport(addDataPre, "excel")}
            totalCount={totalCount > searchCount ? searchCount : totalCount}
            SerchInput={searchInput}
            serchChange={(e) => {
              setSearchInput(e.target.value);
              setPrevSearch(searchInput);
              setPageNo(1);
            }}
            pageNo={pageNo}
            setPageNo={setPageNo}
            entries={entries}
            setEntries={setEntries}
          >
            {payroll_report_loading ? (
              <PageLoading />
            ) : (
              <TableNew
                mt={5}
                nodata={payroll_report_list?.length !== 0 ? false : true}
                headData={Object.values(HeaderData)}
                body={
                  <>
                    {payroll_report_list?.length != 0 &&
                      payroll_report_list?.map((item, i) => (
                        <tr key={i}>
                          {Object.keys(HeaderData).map((val, ind) => (
                            <React.Fragment key={ind}>
                              <td>
                                {val == "role" ? (
                                  getRoleOption(item?.[val])
                                ) : val == "MONTH" ? (
                                  <p
                                    style={{
                                      color: "blue",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      handlePrintSalarySlip(item);
                                    }}
                                  >
                                    {getPaidMonthOption(
                                      item?.[val],
                                      item?.YEAR
                                    )}
                                  </p>
                                ) : val == "PAYMENT_MODE" ? (
                                  getModeOfPayment(item?.[val])
                                ) : val == "BANK_ID" ? (
                                  getBankCode(item?.[val])
                                ) : val == "SALARY_PAID_DATE" ||
                                  val == "DATE" ? (
                                  moment(item[val]).format("DD-MMM-YYYY")
                                ) : (
                                  item[val]
                                )}
                              </td>
                            </React.Fragment>
                          ))}
                        </tr>
                      ))}
                  </>
                }
              />
            )}
          </Pagination3>
        </div>
      )}
    </div>
  );
};

const RightButtonComponent = React.memo(({ ClickEvent, addData }) => {
  const buttons = [
    {
      title: "Staff-Salary-Ledger",
      label: "Staff Salary Ledger",
      action: "staffSalaryLedger",
    },
    {
      title: "Staff-Loan-Ledger",
      label: "Staff Loan Ledger",
      action: "staffLoanLedger",
    },
    {
      title: "Staff-Advance-Ledger",
      label: "Staff Advance Ledger",
      action: "staffAdvanceLedger",
    },
    {
      title: "ESI-REPORT",
      label: "ESI REPORT",
      action: "fetchEsiReport",
    },
    {
      title: "PF-REPORT",
      label: "PF REPORT",
      action: "fetchPfReport",
    },
  ];

  return (
    <div className="ReportMenu-btn">
      {buttons.map(({ title, label, action }) => (
        <button
          key={title}
          className="ReportButtons"
          style={{
            backgroundColor: addData?.title === title ? "#2196f3" : undefined,
          }}
          onClick={() => ClickEvent({ action, title })}
        >
          {label}
        </button>
      ))}
    </div>
  );
});

export default Reports;
